module.exports = __webpack_public_path__ + "static/media/investment.3f4ca06c.svg";